<div class="toolbar">
  <p class="logo-text">Track & Trace - Student Hub Customer Journey</p>
</div>
<router-outlet></router-outlet>